import Axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { format } from 'timeago.js'

import { AuthContext } from '../../context/AuthContext'
import { MessengerContext } from '../../context/MessengerContext'

import './conversation.css'

const Conversation = ({conversation}) => {
    const [user, setUser] = useState({})
    const [latestMessage, setLatestMessage] = useState({})

    const {user: currentUser} = useContext(AuthContext)
    const [currentConversation, setCurrentConversation] = useContext(MessengerContext)

    const API = process.env.REACT_APP_API_URL
    const PF = process.env.REACT_APP_PUBLIC_FOLDER
    const MAX_MSG_LENGTH = 20
    const handleClick = async () => {
        try {
            const communicatorId = conversation.members.find((id) => id !== currentUser._id)
            const {data: {user}} = await Axios.get(API + `users/?userId=${communicatorId}`)
            const {data: {messages}} = await Axios.get(API + `messages/${conversation._id}`)
            setCurrentConversation({
                ...currentConversation, 
                conversation: conversation, 
                messages: messages, 
                communicator: user
            })
        } catch (error) {
            throw error
        }
    }

    useEffect(() => {
        const fetchCommunicator = async () => {
            try {
                const communicatorId = conversation.members.find((id) => id !== currentUser._id)
                const {_id} = conversation
                const {data: {user}} = await Axios.get(API + `users/?userId=${communicatorId}`)
                const {data: {latestMessage}} = await Axios.get(API + `conversations/latestMessage/${_id}`) || {}
                setUser(user)
                setLatestMessage(latestMessage)
            } catch (error) {
                throw error
            }
        }
        fetchCommunicator()
    }, [])

    useEffect(() => {
        if(currentConversation.conversation._id === conversation._id){
            setLatestMessage(currentConversation.messages[currentConversation.messages.length - 1])
        }
    }, [currentConversation.messages])

    return(
        <div className="conversation" onClick={handleClick}>
            <div className="conversationLeft">
              <div className="conversationProfileImgWrapper">
                <img src={user.profilePicture || (PF + "person/default_avatar.jpg")} alt="" className='conversationProfileImg' />
              </div>
            </div>
            <div className="conversationRight">
              <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername">{user.username}</p>
                        {
                            Object.keys(latestMessage).length === 0 ||
                            <p className="lastMessageSendingTime">
                                {format(latestMessage.createdAt)}
                            </p>
                        }
                    </div>
                    <div className="conversationBottomRight">
                        {
                            Object.keys(latestMessage).length === 0 ||
                            <>
                                <p className="lastMessage">
                                    <span style={{ fontWeight: '600' }}>{latestMessage.sender === currentUser._id && 'You : '}</span>
                                    {latestMessage.text.length > MAX_MSG_LENGTH ? `${latestMessage.text.substring(0, MAX_MSG_LENGTH)} ...` : latestMessage.text}
                                </p>
                                {/* <p className="lastMessageStatus">
                                    Seen
                                </p> */}
                            </>
                        }
                    </div>
              </div>
            </div>
        </div>
    )
}

export default Conversation

